<template>
  <div class="comp-contact fit-height" v-if="client">
    <div class="contact-head">
      <div class="inn">
        <div class="info">
          <ul class="meta">
            <li>{{ client.is_supplier?'SUPPLIER':'CLIENT' }}</li>
          </ul>
          <div class="title">
            <template v-if="editClientName">
              <form method="post" action="" @submit.prevent="saveClientName">
                <input type="text" class="form-control" v-model="newClientName" ref="inputClientName"
                       @blur="saveClientName">
              </form>
            </template>
            <template v-else>
              <span>{{ client.name }}</span>
              <a href="javascript:;" class="edit icon-pencil"
                 @click="editClientName = true"></a>
            </template>
          </div>
        </div>
      </div>
    </div>

    <div class="auto-height contact-body">
      <div class="tabs">
        <ul>
          <li v-for="(tab, index) in tabs" :key="index">
            <a href="javascript:;" :class="{active: curTab==tab.value}" @click="curTab = tab.value">
              {{ tab.label }}
            </a>
          </li>
        </ul>
      </div>

      <template v-if="curTab == 'details-contacts'">
        <company-details></company-details>
        <hr class="divider">
        <company-contacts></company-contacts>
      </template>
      <template v-if="curTab == 'notes'">
        <company-notes></company-notes>
      </template>
    </div>
  </div>
</template>

<script>

  import {mapState} from 'vuex'
  import ServiceClient from '@/services/client'
  import CompanyDetails from './CompanyDetails.vue';
  import CompanyContacts from './CompanyContacts.vue';
  import CompanyNotes from './CompanyNotes.vue';

  export default {
    components: {
      CompanyDetails,
      CompanyContacts,
      CompanyNotes,
    },
    data() {
      return {
        editClientName: false,
        newClientName: '',
        tabs: [
          {value: 'details-contacts', label: 'DETAILS + CONTACTS'},
          {value: 'notes', label: 'NOTES'},
        ],
        curTab: 'details-contacts',
        contact: {
          title: 'COMPANY NAME',
        },
      }
    },
    props: ['itemId', 'tab'],
    computed: mapState({
      client: state => state.client.client
    }),
    watch: {
      itemId: 'init',
      editClientName(newVal) {
        let self = this;
        if (newVal) {
          self.newClientName = self.client.name;
          setTimeout(() => {
            self.$refs.inputClientName.focus();
          }, 200);
        }
      },
    },
    mounted() {
      this.init();
    },
    methods: {
      init() {
        if (this.tab)
          this.curTab = this.tab;
        this.$store.dispatch('GET_CLIENT', this.itemId);
      },
      saveClientName() {
        let self = this;
        if (self.client.name != self.newClientName) {
          ServiceClient.save(self.itemId, {name: self.newClientName}, function(){
            self.client.name = self.newClientName;
            self.editClientName = false;
          });
        }
      },
    }
  }
</script>
